export const itemBankExamsI18n = {
  itemBankExams: {
    howItWorks: 'Build Form 0 from a course\'s current Storyline exam, activate it, then switch that course quiz to the item bank. '
      + 'Learners finish the course content in Storyline and take the exam here; passing it completes the course.',
    loadError: 'Could not load exams',
    forms: {
      title: 'Forms',
      buildFormZero: 'Build Form 0 from Storyline',
      empty: 'No forms yet',
      emptyHint: 'Start with Form 0: the same questions and pass mark as the course\'s Storyline exam.',
      viewTitle: 'Form',
      viewFacts: '{items} questions · sat {attempts} times',
      columns: {
        code: 'Code',
        name: 'Name',
        language: 'Language',
        status: 'Status',
        questions: 'Questions',
        attempts: 'Attempts',
        created: 'Created',
      },
      statuses: {
        draft: 'Draft',
        active: 'Active',
        retired: 'Retired',
      },
      actions: {
        view: 'View',
        activate: 'Activate',
        retire: 'Retire',
        delete: 'Delete',
      },
      confirm: {
        activate: {
          title: 'Activate {code}?',
          body: 'Learners on quizzes delivered by the item bank in this language can be given this form.',
          done: '{code} is active.',
        },
        retire: {
          title: 'Retire {code}?',
          body: 'No new attempts will use this form. Attempts already started can still be finished and their results stay.',
          done: '{code} is retired.',
        },
        delete: {
          title: 'Delete {code}?',
          body: 'The draft form is removed. Its items stay in the item bank.',
          done: '{code} was deleted.',
        },
      },
    },
    delivery: {
      title: 'Exam delivery',
      search: 'Search courses',
      configuredOnly: 'Configured only',
      empty: 'No course quizzes match.',
      saved: 'Exam delivery saved.',
      dialogTitle: 'Exam delivery',
      quizFacts: '{questions} questions, pass {pass}%',
      sourceLabel: 'Final exam comes from',
      packageHint: 'The Storyline package delivers and grades the final exam, as it does today.',
      itemBankHint: 'Storyline delivers the course content only. When it finishes, the learner takes the exam from an active form here. '
        + 'Reaching the end of the content no longer completes the course; passing the exam does.',
      pilotsLabel: 'Unscored pilot questions per attempt',
      pilotsHint: 'Field-testing items mixed into English attempts. They never count toward the score.',
      backLabel: 'Allow going back to earlier questions',
      backHint: 'Off: learners answer in order and cannot return once they move on; Next needs an answer.',
      reviewLabel: 'Show the answer review before submitting',
      reviewHint: 'Off: after the last question learners go straight to the submit confirmation.',
      packageRollbackNote: 'Once a package is re-published without its exam scene, switching back to Storyline package '
        + 'leaves this course with no exam. To roll back, re-upload the old package first.',
      noForm: 'There is no active form with exactly {questions} questions in this program and language yet. '
        + 'Build and activate Form 0 first.',
      otherProgram: 'This quiz is set up under program {code}. Saving moves it to {current}.',
      columns: {
        course: 'Course',
        language: 'Language',
        questions: 'Questions',
        passMark: 'Pass mark',
        source: 'Exam from',
        pilots: 'Pilots',
        formsReady: 'Forms ready',
      },
      sources: {
        package: 'Storyline package',
        item_bank: 'Item bank',
      },
    },
    formZero: {
      title: 'Build Form 0 from Storyline',
      subtitle: 'Copies the course\'s current Storyline exam into the item bank as a draft form with the same questions.',
      quizLabel: 'Course quiz',
      fileLabel: 'data.js from the published course',
      fileHint: 'In the Storyline publish, open html5/data/js and upload data.js. It holds every quiz question.',
      check: 'Check file',
      back: 'Choose another file',
      create: 'Create draft Form 0',
      created: 'Draft {code} created. Review it, then activate it.',
      facts: 'Storyline: {questions} questions, pass {pass}% · Course quiz: {total} questions, pass {quizPass}%',
      storylineQuizLabel: 'Storyline quiz',
      storylineQuiz: '{questions} questions, pass {pass}%',
      codeLabel: 'Code',
      nameLabel: 'Name',
      authorLabel: 'Accountable SME',
      authorHint: 'Recorded as the author of the copied items. They are not paid for them.',
      mappingHint: 'Each question needs a risk factor and learning outcome. Suggestions are filled in from matching words; check each one.',
      unmapped: '{count} still to map.',
      columns: {
        question: 'Question and correct answer',
        domain: 'Risk factor',
        outcome: 'Learning outcome',
      },
      existing: {
        reused: 'Already in the bank as item #{id}',
        conflict: 'Item #{id} differs from this question',
      },
    },
  },
};

export const itemBankExamsI18nEs = {
  itemBankExams: {
    howItWorks: 'Crea el Formulario 0 a partir del examen actual de Storyline del curso, actívalo '
      + 'y luego cambia ese cuestionario al banco de ítems. '
      + 'El alumno termina el contenido en Storyline y presenta el examen aquí; aprobarlo completa el curso.',
    loadError: 'No se pudieron cargar los exámenes',
    forms: {
      title: 'Formularios',
      buildFormZero: 'Crear Formulario 0 desde Storyline',
      empty: 'Todavía no hay formularios',
      emptyHint: 'Empieza con el Formulario 0: las mismas preguntas y la misma nota mínima que el examen de Storyline del curso.',
      viewTitle: 'Formulario',
      viewFacts: '{items} preguntas · presentado {attempts} veces',
      columns: {
        code: 'Código',
        name: 'Nombre',
        language: 'Idioma',
        status: 'Estado',
        questions: 'Preguntas',
        attempts: 'Intentos',
        created: 'Creado',
      },
      statuses: {
        draft: 'Borrador',
        active: 'Activo',
        retired: 'Retirado',
      },
      actions: {
        view: 'Ver',
        activate: 'Activar',
        retire: 'Retirar',
        delete: 'Eliminar',
      },
      confirm: {
        activate: {
          title: '¿Activar {code}?',
          body: 'Los alumnos de cuestionarios entregados por el banco de ítems en este idioma pueden recibir este formulario.',
          done: '{code} está activo.',
        },
        retire: {
          title: '¿Retirar {code}?',
          body: 'Ningún intento nuevo usará este formulario. Los intentos ya iniciados pueden terminarse y sus resultados se conservan.',
          done: '{code} está retirado.',
        },
        delete: {
          title: '¿Eliminar {code}?',
          body: 'Se elimina el formulario en borrador. Sus ítems permanecen en el banco.',
          done: '{code} se eliminó.',
        },
      },
    },
    delivery: {
      title: 'Entrega del examen',
      search: 'Buscar cursos',
      configuredOnly: 'Solo configurados',
      empty: 'Ningún cuestionario coincide.',
      saved: 'Entrega del examen guardada.',
      dialogTitle: 'Entrega del examen',
      quizFacts: '{questions} preguntas, aprueba con {pass}%',
      sourceLabel: 'El examen final viene de',
      packageHint: 'El paquete de Storyline entrega y califica el examen final, como hoy.',
      itemBankHint: 'Storyline entrega solo el contenido. Al terminarlo, el alumno presenta el examen de un formulario activo aquí. '
        + 'Llegar al final del contenido ya no completa el curso; aprobar el examen sí.',
      pilotsLabel: 'Preguntas piloto sin calificar por intento',
      pilotsHint: 'Ítems en prueba mezclados en los intentos en inglés. Nunca cuentan para la calificación.',
      backLabel: 'Permitir volver a preguntas anteriores',
      backHint: 'Desactivado: el alumno responde en orden y no puede volver al avanzar; Siguiente requiere una respuesta.',
      reviewLabel: 'Mostrar la revisión de respuestas antes de enviar',
      reviewHint: 'Desactivado: tras la última pregunta el alumno pasa directo a la confirmación del envío.',
      packageRollbackNote: 'Si un paquete se vuelve a publicar sin su escena de examen, volver a Paquete de Storyline '
        + 'deja este curso sin examen. Para revertir, vuelve a subir primero el paquete anterior.',
      noForm: 'Todavía no hay un formulario activo con exactamente {questions} preguntas en este programa e idioma. '
        + 'Crea y activa el Formulario 0 primero.',
      otherProgram: 'Este cuestionario está configurado en el programa {code}. Al guardar pasa a {current}.',
      columns: {
        course: 'Curso',
        language: 'Idioma',
        questions: 'Preguntas',
        passMark: 'Nota mínima',
        source: 'Examen desde',
        pilots: 'Piloto',
        formsReady: 'Formularios listos',
      },
      sources: {
        package: 'Paquete de Storyline',
        item_bank: 'Banco de ítems',
      },
    },
    formZero: {
      title: 'Crear Formulario 0 desde Storyline',
      subtitle: 'Copia el examen actual de Storyline del curso al banco de ítems como un formulario en borrador con las mismas preguntas.',
      quizLabel: 'Cuestionario del curso',
      fileLabel: 'data.js del curso publicado',
      fileHint: 'En la publicación de Storyline, abre html5/data/js y sube data.js. Contiene todas las preguntas.',
      check: 'Revisar archivo',
      back: 'Elegir otro archivo',
      create: 'Crear Formulario 0 en borrador',
      created: 'Borrador {code} creado. Revísalo y luego actívalo.',
      facts: 'Storyline: {questions} preguntas, aprueba con {pass}% · Cuestionario: {total} preguntas, aprueba con {quizPass}%',
      storylineQuizLabel: 'Cuestionario de Storyline',
      storylineQuiz: '{questions} preguntas, aprueba con {pass}%',
      codeLabel: 'Código',
      nameLabel: 'Nombre',
      authorLabel: 'Experto responsable',
      authorHint: 'Queda como autor de los ítems copiados. No se le paga por ellos.',
      mappingHint: 'Cada pregunta necesita un factor de riesgo y un resultado de aprendizaje. '
        + 'Las sugerencias vienen de palabras en común; revisa cada una.',
      unmapped: 'Faltan {count} por asignar.',
      columns: {
        question: 'Pregunta y respuesta correcta',
        domain: 'Factor de riesgo',
        outcome: 'Resultado de aprendizaje',
      },
      existing: {
        reused: 'Ya está en el banco como ítem #{id}',
        conflict: 'El ítem #{id} difiere de esta pregunta',
      },
    },
  },
};
